export default __webpack_public_path__ + "static/media/tags.d8e7eed8.jpg";